import HeroBgAnimation from "../HeroBgAnimation";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  SocialMediaIcons,
  SocialMediaIcon,
  ResumeButton,
  MobileSubTitle,
} from "./HeroStyle";
import HeroImg from "../../images/HeroImage.png";
// import Loader from "../Loader/Loader";
import Typewriter from "typewriter-effect";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Bio } from "../../data/constants";
import Background from "../Background/Background";

const HeroSection = () => {
  const [bio] = useState(Bio);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  // No need to fetch data as we're using local constants

  return (
    <div id="about" style={{ width: "100%", height: '100vh', position: "relative" }}>
      <h1>ABOUT</h1>
      <HeroContainer>
        <HeroBg>
          {/* <HeroBgAnimation /> */}
          <Background
          colors={["#5227FF", "#FF9FFC", "#B19EEF"]}
          mouseForce={20}
          cursorSize={100}
          isViscous={false}
          viscous={30}
          iterationsViscous={32}
          iterationsPoisson={32}
          resolution={0.5}
          isBounce={false}
          autoDemo={true}
          autoSpeed={0.5}
          autoIntensity={2.2}
          takeoverDuration={0.25}
          autoResumeDelay={3000}
          autoRampDuration={0.6}
        />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer id="Left">
            <Title>
              Hi, I am <br /> {bio?.name}
            </Title>
            <TextLoop>
              I am a
              <Span>
                <Typewriter
                  options={{
                    strings: bio?.roles || [],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{bio?.description}</SubTitle>
            <SocialMediaIcons>
              <SocialMediaIcon
                title="Email"
                href="mailto:ss3177806@gmail.com"
                target="display"
              >
                <EmailIcon />
              </SocialMediaIcon>
              <SocialMediaIcon title="mobile" target="display">
                <PhoneIcon />
              </SocialMediaIcon>
              <SocialMediaIcon
                href="https://www.instagram.com/shiva_shankar__goddumarri/"
                target="display"
                title="Instagram"
              >
                <InstagramIcon />
              </SocialMediaIcon>
              <SocialMediaIcon target="display" title="Whatsapp">
                <WhatsAppIcon />
              </SocialMediaIcon>
            </SocialMediaIcons>
            <ResumeButton href="http://www.linkedin.com/in/shiva-shankar-goddumarri-458341196">
              <span
                style={{ position: "absolute", left: "50px", bottom: "5px" }}
              >
                <LinkedInIcon />
              </span>
              <span style={{ marginLeft: "40px" }}>Connect</span>
            </ResumeButton>
            <MobileSubTitle>{bio?.description}</MobileSubTitle>
          </HeroLeftContainer>
          <HeroRightContainer id="Right">
            <Img src={HeroImg} alt="hero-image" />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
